import { createTRPCReact, httpLink } from '@trpc/react-query';
import type { RefObject } from 'react';
import SuperJSON from 'superjson';
import { VITE_TRPC_API_URI } from '#pie/env';
import type { AppRouter } from '#pie/internal/api/pie-public-trpc/router';
import type { HeaderSchema } from '#pie/internal/api/pie-public-trpc/trpc';
import type { Locale } from './utils/i18n';

export const trpc = createTRPCReact<AppRouter>({});

export function getBatchLink({
  localeRef,
  urlPathname,
}: {
  localeRef: RefObject<Locale>;
  urlPathname: string;
}) {
  return httpLink<AppRouter>({
    headers: () =>
      ({
        'x-edsn-locale': localeRef.current,
        'x-edsn-path': urlPathname,
      }) satisfies HeaderSchema,
    url: VITE_TRPC_API_URI + '/api/trpc',
    transformer: SuperJSON,
  });
}
